module.exports = __webpack_public_path__ + "img/round_trial.6ba34ba3.svg";